// src/components/Testimonial.js
import React from 'react';
import StarRating from './StarRating';

const Testimonial = ({ name, review, rating }) => (
  <div className="testimonial-card">
    <span className="testimonial-card__quote" aria-hidden="true">"</span>
    <p className="testimonial-card__review">{review}</p>
    <div className="testimonial-card__footer">
      <span className="testimonial-card__name">— {name}</span>
      <StarRating rating={rating} />
    </div>
  </div>
);

export default Testimonial;
